<template>
<div class="profile-card card" @click="$openPage(info.url)">
  <div class="info">
    <div>
      <div class="tag">{{info.newsTypeName}}</div>
      <div class="title text-overflow" v-html="info.title"></div>
    </div>
    <p class="text-overflow2">{{info.summary}}</p>
  </div>
  <div class="bottom">
    <span>来源：{{info.publisher}}</span>
    <span>{{info.publishTime.slice(0,10)}}发布</span>
  </div>
</div>
</template>

<script>
import VImg from '@/components/VImg.vue'

export default{
  props: {
    info:{}
  },
  data(){
    return{}
  },
  components: {VImg}

}
</script>


<style scoped lang="scss">
.profile-card{
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 163px;
  cursor: pointer;
  border-bottom: 1px solid #EEEEEE;
  .info{
    >div{
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      overflow-x: hidden;
      >.tag{
        padding: 0 8px;
        height: 22px;
        border: 1px solid #EA0B06;
        text-align: center;
        margin-right: 8px;
        font-weight: 400;
        font-size: 12px;
        color: #EA0B06;
        line-height: 20px;
      }
      >.title{
        flex: 1;
        font-weight: 400;
        font-size: 16px;
        color: #262626;
        line-height: 22px;
        margin-bottom: 0;
      }
    }
    >p{
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 20px;
    }
  }
  .bottom{
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    >:first-child{
     margin-right: 24px;
    }
  }
}
</style>
